import {Icon20MessageOutline} from "@vkontakte/icons";
import {Button} from "@vkontakte/vkui";
import React from "react";
import {useSnackbar} from "../../context/SnackbarContext";
import {getTelegramUserId, openTelegramShare} from "../../services/telegramWebApp";

// buildInviteLink формирует deeplink в Telegram-бота с реферальным startapp-параметром.
const buildInviteLink = () => {
    const botUsername = (process.env.REACT_APP_TELEGRAM_BOT_USERNAME || "")
        .trim()
        .replace(/^@/, "");
    const userId = getTelegramUserId();
    const startAppParam = userId ? `ref_${userId}` : "invite";

    if (botUsername) {
        return `https://t.me/${botUsername}?startapp=${encodeURIComponent(startAppParam)}`;
    }

    if (typeof window !== "undefined" && window.location?.origin) {
        return window.location.origin;
    }

    return "https://t.me";
};

export const InviteButton = () => {
    const {showSuccessSnackbar, showErrorSnackbar} = useSnackbar();

    const inviteButtonHandler = () => {
        const inviteLink = buildInviteLink();
        const isOpened = openTelegramShare({
            text: "🎮 I challenge you to Wordmania! Guess words fast, climb the leaderboard, and earn rewards. Tap to play 👆",
            url: inviteLink,
        });

        if (!isOpened) {
            showErrorSnackbar("Failed to send invite");
            return;
        }

        showSuccessSnackbar("Invite dialog opened");
    }

    return (
        <Button
            appearance={'overlay'}
            className={"rounded bg-yellow-400 hover:bg-yellow-500 text-gray-800 border-solid border-2 border-yellow-400/20"}
            size={"m"}
            before={<Icon20MessageOutline/>}
            onClick={inviteButtonHandler}>
            Invite a friend
        </Button>
    );
};
